import { z } from "zod";

export const getProjectTimelineDiaryQuerySchema = z
	.object({
		order: z.enum(["asc", "desc"]),
		startDate: z.string().optional(),
		endDate: z.string().optional(),
		includeNotes: z.boolean(),
		includeMedia: z.boolean(),
		includeUnpublishedAssignments: z.boolean(),
	})
	.superRefine((data, ctx) => {
		if (data.startDate && data.endDate && data.startDate > data.endDate) {
			ctx.addIssue({
				code: "custom",
				message: "Start date cannot be after end date.",
				path: ["startDate"],
			});
		}
	});

export type GetProjectTimelineDiaryQuerySchema = z.infer<typeof getProjectTimelineDiaryQuerySchema>;
